module.exports = __webpack_public_path__ + "static/CNX Home 01 Trans-439eb527ea136e032ea2b74a9bce59b3.png";